// Math shared by the Event Ops funnel cards: the "Signed up" count
// (SCRUM-449), the RSVP base later cards anchor on and the meet's athlete
// count (SCRUM-463). Kept out of EventOps.jsx, which pulls in
// axios via Services/arndAPI.js and can't be imported into a Jest test here
// (see src/App.test.js's pre-existing ESM failure for the same reason).

import eventAthletes from './eventAthletes.json';

/**
 * Everyone who got at least as far as signing up
 * during this event — leads (signed up, not joined) plus everyone who
 * joined (RSVP'd). `null` while leads data hasn't loaded yet, mirroring the
 * card's own '—' placeholder for that case.
 */
export const signedUpCount = (leads, joinedParents) =>
  leads ? leads.count + joinedParents : null;

/**
 * Percentage base + label for the funnel cards (SCRUM-463). With the meet's
 * athlete count tracked (eventAthletes.json), every card is a share of it;
 * RSVPs uses its athlete count, the other stages count parents (or scans /
 * devices), which runs 5–12% below athletes because siblings share a
 * parent. Without a tracked count, cards after RSVPs are shares of RSVP'd
 * parents and the cards above RSVPs show no percentage.
 */
export const funnelBase = (f, meet) =>
  meet
    ? { base: meet.athletes, baseLabel: 'of athletes', aboveRsvp: true }
    : { base: f.joinedParents, baseLabel: 'of RSVPs', aboveRsvp: false };

/**
 * SCRUM-463: athletes competing at the meet, tracked by hand in
 * eventAthletes.json (keyed by event id) until it becomes an input on the
 * event page. `null` for an event with no entry — the Athletes card then
 * doesn't render.
 */
export const athleteCount = (eventId, table = eventAthletes) => table[eventId] ?? null;
